<template>
  <section class="relative w-full custom-scrollbar overflow-x">
    <div class="overflow-x-auto custom-scrollbar">
      <table class="w-full mt-6 bg-white table-auto min-w-max">
        <thead class="text-gray-400 bg-white border-b border-gray-200">
          <tr>
            <th class="p-3 text-sm text-left">Description</th>
            <th class="p-3 text-sm text-left">Tipe File</th>
            <th class="p-3 text-sm text-left">Actions</th>
          </tr>
        </thead>
        <tbody>
          <tr
            class="border-b"
            v-for="outputFile in outputFiles"
            :key="outputFile._id"
          >
            <td class="p-3 text-sm">{{ outputFile.description }}</td>
            <td class="p-3 text-sm">{{ outputFile.type_file }}</td>
            <td class="p-3">
              <div class="flex items-center">
                <Button
                  class="mr-3 rounded-full shadow-none hover:bg-blue-100 text-primary"
                  @click="$emit('on-edit', outputFile)"
                >
                  <font-awesome-icon icon="fa-pen-to-square" />
                </Button>
                <Button
                  class="text-red-500 rounded-full shadow-none hover:bg-red-100"
                  @click="$emit('on-delete', outputFile._id)"
                >
                  <font-awesome-icon icon="fa-trash-alt" />
                </Button>
              </div>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  </section>
</template>

<script>
import Button from "@/components/Button.vue";
export default {
  name: "TableOutputFile",
  props: {
    outputFiles: {
      type: Array,
      required: true,
    },
  },
  components: {
    Button,
  },
};
</script>
